export enum RecommendationStatusEnum {
    Ativo = 1,
    Bloqueado = 2,
    Pendente = 3,
    Inativo = 4,
}